import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetUnderscoreLocale } from './recommendationAccessorGetUnderscoreLocale'

export const recommendationAccessorGetLocalizedProductName = ({
  locale,
  product,
}: {
  locale: LOCALE
  product?: GkAirRecommendedProductDataWeb
}): string => {
  if (!product) {
    return ''
  }
  const productName =
    product[`name_${recommendationAccessorGetUnderscoreLocale(locale)}`]

  if (!productName) {
    return ''
  }

  return productName
}
